export const encyclopediaZhCN = {
  // Shared
  'encyclopedia.lockAria': '已锁定 — 解锁后可阅读',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': '魔典',
  'encyclopedia.page.seoDescription':
    '搜索格林威德的活魔典——怪物、咒语、种族、物品、地点等。',
  'encyclopedia.page.heading': '魔典',
  'encyclopedia.page.subtitle': '格林威德中每一恐怖、每一咒语与每一传说的活魔典。',
  'encyclopedia.page.searchPlaceholder': '搜索 {plural}…',
  'encyclopedia.page.searchAria': '搜索 {plural}',
  'encyclopedia.page.clearSearch': '清除搜索',
  'encyclopedia.page.systemNotLivePrefix': '幕纱尚未为以下仪式开启',
  'encyclopedia.page.systemNotLiveSuffix':
    '。绑定此仪式的知识尚未渗透——其魔典仍在黑暗之外。',
  'encyclopedia.page.returnToAllSystems': '返回所有仪式',
  'encyclopedia.page.settingNotLivePrefix': '地名',
  'encyclopedia.page.settingNotLiveSuffix':
    '仍在绘制中——其条目尚未绑定至背景设定。待制图师完成工作后，才会有答复。',
  'encyclopedia.page.returnToAllRealms': '返回所有王国',
  'encyclopedia.page.filteringBy': '筛选条件',
  'encyclopedia.page.filterSystem': '仪式"{label}"',
  'encyclopedia.page.filterCanon': '正典层"{label}"',
  'encyclopedia.page.filterSetting': '背景设定"{label}"',
  'encyclopedia.page.canonNote': '正典层在实体于API中被标记后才适用（见 _docs/13）。 ',
  'encyclopedia.page.clear': '清除',
  'encyclopedia.page.hide': '隐藏',
  'encyclopedia.page.filter': '筛选',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': '解锁 {name}（格林威德内容）',
  'encyclopedia.entityCard.viewAria': '查看 {name} 条目',

  // EntityGrid
  'encyclopedia.grid.paginationAria': '分页（{position}）',
  'encyclopedia.grid.prev': '上一页',
  'encyclopedia.grid.next': '下一页',
  'encyclopedia.grid.pageOf': '第 {page} 页，共 {totalPages} 页',
  'encyclopedia.grid.resultsAria': '{plural} 条结果',
  'encyclopedia.grid.scrying': '正在搜索档案库…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': '按降序排序',
  'encyclopedia.grid.sortAscAria': '按升序排序',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': '视图模式',
  'encyclopedia.grid.gridViewAria': '网格视图',
  'encyclopedia.grid.listViewAria': '列表视图',
  'encyclopedia.grid.jumpToLetterAria': '跳转至首字母',
  'encyclopedia.grid.all': '全部',
  'encyclopedia.grid.letterSymbolAria': '以数字或符号开头的条目',
  'encyclopedia.grid.letterAria': '以 {letter} 开头的条目',
  'encyclopedia.grid.emptyTitle': '档案库沉寂无声',
  'encyclopedia.grid.emptyForLetter': '没有 {plural} 的名称以"{letter}"开头。',
  'encyclopedia.grid.emptyAll': '没有 {plural} 响应你的召唤。',
  'encyclopedia.grid.turningPages': '正在翻页…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label}（无图稿）',
  'encyclopedia.entityImage.noVision': '无视觉',

  // FacetSidebar
  'encyclopedia.facets.all': '全部',
  'encyclopedia.facets.soon': '即将推出',
  'encyclopedia.facets.navAria': '实体类型筛选器',
  'encyclopedia.facets.clearAll': '清除所有筛选',
  'encyclopedia.facets.lorebook': '知识书',
  'encyclopedia.facets.gameSystem': '游戏系统',
  'encyclopedia.facets.canonLayer': '正典层',
  'encyclopedia.facets.setting': '背景设定',

  // GlobalSearch
  'encyclopedia.globalSearch.title': '搜索幕纱',
  'encyclopedia.globalSearch.placeholder': '搜索怪物、咒语、地点、知识…',
  'encyclopedia.globalSearch.queryAria': '搜索查询',
  'encyclopedia.globalSearch.loading': '正在搜寻…',
  'encyclopedia.globalSearch.empty': '黑暗中对于"{q}"毫无反应。',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': '格林威德内容 — 解锁后可阅读',
  'encyclopedia.lockBadge.label': '已锁定',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': '已锁定内容',
  'encyclopedia.lockedGate.defaultTitle': '此知识已封禁',
  'encyclopedia.lockedGate.body':
    '格林威德的怪兽志、咒语与传说绑定于格林威德大灾变。开放式SRD正典保持免费 — 但要踏入永恒的暮光本身，需获得此书。',
  'encyclopedia.lockedGate.unlockCta': '解锁格林威德',
  'encyclopedia.lockedGate.signInCta': '已是支持者？登录',
  'encyclopedia.lockedGate.backerNote':
    '为格林威德众筹的支持者已拥有此内容 — 登录以在你的账户上解锁。',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — 掷骰结果 {total}',
  'encyclopedia.table.noRowMatched': '没有行匹配 {total}。',
  'encyclopedia.table.loading': '正在展开表格…',
  'encyclopedia.table.error': '无法绘制此表格。',
  'encyclopedia.table.roll': '掷骰 {formula}',
  'encyclopedia.table.lastRoll': '上次掷骰：{value}',
  'encyclopedia.table.noMatchingRow': ' · 无匹配行',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': '条目',
  'encyclopedia.detail.addedToCampaign': '已添加至你的战役。',
  'encyclopedia.detail.addError': '无法连接战役金库。稍后重试。',
  'encyclopedia.detail.unknownType': '未知条目类型。',
  'encyclopedia.detail.seoDescription': '{name} — 格林威德魔典中的一条 {label}。',
  'encyclopedia.detail.breadcrumbAria': '面包屑',
  'encyclopedia.detail.breadcrumbRoot': '魔典',
  'encyclopedia.detail.sourceVersionAria': '来源版本',
  'encyclopedia.detail.versionConsolidated': '综合版',
  'encyclopedia.detail.versionBook': '特定书籍版',
  'encyclopedia.detail.removeBookmarkAria': '移除书签',
  'encyclopedia.detail.addBookmarkAria': '添加书签',
  'encyclopedia.detail.bookmarked': '已添加书签',
  'encyclopedia.detail.bookmark': '书签',
  'encyclopedia.detail.addToCampaign': '添加至战役',
  'encyclopedia.detail.sealedTitle': '{name} 已被封禁',
  'encyclopedia.detail.bookVariantNote':
    '显示综合记录；书籍版的变体文本将在书籍版本链接后出现。',
  'encyclopedia.detail.tablistAria': '条目部分',
  'encyclopedia.detail.tab.lore': '知识',
  'encyclopedia.detail.tab.stats': '数据',
  'encyclopedia.detail.tab.gallery': '图库',
  'encyclopedia.detail.tab.relations': '关系',
  'encyclopedia.detail.tab.discussions': '讨论',
  'encyclopedia.detail.tab.claims': '玩家声索',
  'encyclopedia.detail.loading': '正在唤醒条目…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': '正在挖掘知识…',
  'encyclopedia.lore.empty': '此条目的历史尚未被记录。',

  // tabs/StatsTab
  'encyclopedia.stats.loading': '正在读取符文…',
  'encyclopedia.stats.empty': '没有为此条目记录的机制。',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': '正在显影幻象…',
  'encyclopedia.gallery.emptyTitle': '尚无幻象',
  'encyclopedia.gallery.emptyBody': '没有图稿绑定至此条目。在金库中贡献一幅。',
  'encyclopedia.gallery.artworkAlt': '实体图稿',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': '正在收集低语…',
  'encyclopedia.discussions.emptyTitle': '大厅寂然无声',
  'encyclopedia.discussions.emptyBody': '成为第一个与同行旅人讨论此条目的人。',
  'encyclopedia.discussions.startCta': '开始讨论',
  'encyclopedia.discussions.untitledThread': '无标题讨论',
  'encyclopedia.discussions.byAuthor': '作者：{author}',
  'encyclopedia.discussions.replyCount': '{count} 条回复',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': '你的声索已被记录以待审核。',
  'encyclopedia.claims.recordError': '文书无法记录你的声索。稍后重试。',
  'encyclopedia.claims.loading': '正在查询正典…',
  'encyclopedia.claims.emptyTitle': '尚无玩家声索',
  'encyclopedia.claims.emptyBody': '没有旅人将他们的传奇编入此条目。',
  'encyclopedia.claims.claimCta': '声索此项',
  'encyclopedia.claims.signInCta': '登录以进行声索',
  'encyclopedia.claims.untitledClaim': '无标题声索',
  'encyclopedia.claims.byAuthor': '作者：{author}',
  'encyclopedia.claims.addCta': '添加你的声索',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': '此条目',
  'encyclopedia.relations.relationLabel': '关系 {index}',
  'encyclopedia.relations.kindredLabel': '同族 {index}',
  'encyclopedia.relations.loading': '正在追溯命运之线…',
  'encyclopedia.relations.hintIntro': '点击节点以前往该条目。显示的线条为',
  'encyclopedia.relations.hintCanonical': '正典关系。',
  'encyclopedia.relations.hintKindred': '相同类型的同族。',
} as const
